import React, { Component } from 'react';
import Carousel from 'nuka-carousel';
import { connect } from 'react-redux';
import * as actions from 'state/modules/assign';
import { CarouselHeader, InspCarouselItem, InspectionCarouselFooter, OverrideCarousel, CarouselLeftArrow, CarouselRightArrow } from 'components';
import moment from 'moment';
import _ from 'lodash';
import { InspectionsPopup } from 'containers';//eslint-disable-line
// import moment from 'moment';
// import _ from 'lodash';
import styles from './InspCarousel.css';

/**
* detect IE
* returns version of IE or false, if browser is not Internet Explorer
*/
const detectIE = () => {
  const ua = window.navigator.userAgent;
  const msie = ua.indexOf('MSIE ');
  if (msie > 0) {
    // IE 10 or older => return version number
    return true;
  }

  const trident = ua.indexOf('Trident/');
  if (trident > 0) {
    // IE 11 => return version number
    return true;
  }

  const edge = ua.indexOf('Edge/');
  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return false;
  }

  // other browser
  return false;
};

// Get IE or Edge browser version
const isIE = detectIE();

class InspCarousel extends Component { //eslint-disable-line
  static propTypes = {
    listData: React.PropTypes.shape({}),
    clickedIndex: React.PropTypes.number,
    strings: React.PropTypes.shape({
      contactinfo: React.PropTypes.string
    }),
    closeCarousel: React.PropTypes.func,
    currentLanguage: React.PropTypes.string,
    ownerId: React.PropTypes.string,
    tabIndexLeadsCheck: React.PropTypes.number,
    fetchPolicyDataAssign: React.PropTypes.func,
    policyData: React.PropTypes.shape({}),
    campaignData: React.PropTypes.shape([])
  }

  constructor(props) {
    super(props);
    this.state = {
      headerIndex: 0,
      CarousalHeaderTitle: this.props.strings.contactinfo,
      CarousalHeaderSubTitle: '',
      insButtonCarouselType: '',
      tableData: [],
      campaignDataRecordsROP: [],
      campaignDataRecordsOthers: []
    };
  }
  componentWillMount() {
    const propsData = this.props.listData;
    const promised = this.props.fetchPolicyDataAssign('cica_policyinformation', propsData.personId, 'url', this.props.ownerId);
    const campaignDataRecordsROP = [];
    const campaignDataRecordsOthers = [];
    const { campaignData } = this.props;
    promised.then((response) => {
      this.setState({ tableData: this.getTableData(response) });
    }, () => {
      this.setState({ tableData: this.getTableData([]) });
    });

    const campaignDataRecordsNet = campaignData.filter(recordObj =>
      propsData.personId && recordObj.cica_name &&
      propsData.personId.indexOf(recordObj.cica_name) > -1);

    if (campaignDataRecordsNet && campaignDataRecordsNet.length > 0) {
      campaignDataRecordsNet.map((netRecordObj) => {
        if (netRecordObj.cica_isrop &&
          netRecordObj.cica_isrop === 'true') {
          campaignDataRecordsROP.push(netRecordObj);
        } else {
          campaignDataRecordsOthers.push(netRecordObj);
        }
        return '';
      });
      this.setState({
        campaignDataRecordsROP,
        campaignDataRecordsOthers
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { headerIndex } = this.state;
    const { strings, listData } = nextProps;
    if (!_.isEqual(nextProps.listData, this.props.listData)) {
      const propsData = nextProps.listData;
      const promised = this.props.fetchPolicyDataAssign('cica_policyinformation', propsData.personId, 'url', this.props.ownerId);
      const campaignDataRecordsROP = [];
      const campaignDataRecordsOthers = [];
      const { campaignData } = this.props;
      promised.then((response) => {
        this.setState({ tableData: this.getTableData(response) });
      }, () => {
        this.setState({ tableData: this.getTableData([]) });
      });

      const campaignDataRecordsNet = campaignData.filter(recordObj =>
        propsData.personId && recordObj.cica_name &&
        propsData.personId.indexOf(recordObj.cica_name) > -1);

      if (campaignDataRecordsNet && campaignDataRecordsNet.length > 0) {
        campaignDataRecordsNet.map((netRecordObj) => {
          if (netRecordObj.cica_isrop &&
            netRecordObj.cica_isrop === 'true') {
            campaignDataRecordsROP.push(netRecordObj);
          } else {
            campaignDataRecordsOthers.push(netRecordObj);
          }
          return '';
        });
        this.setState({
          campaignDataRecordsROP,
          campaignDataRecordsOthers
        });
      }
    }
    if (this.props.currentLanguage !== nextProps.currentLanguage) {
      switch (headerIndex) {
        case 0:
          this.setState({
            CarousalHeaderTitle: (listData.cica_calltype === 'Business') ? strings.residentialInfo : strings.contactinfo
          });
          return;
        case 1:
          this.setState({
            CarousalHeaderTitle: (listData.cica_calltype === 'Business') ? strings.contactinfo : strings.businessInfo
          });
          return;
        case 2:
          this.setState({
            CarousalHeaderTitle: strings.policydetails
          });
          return;
        default:
          return;
      }
    }
  }

  getRopTableData = () => {
    const { strings } = this.props;
    const tableFillData = {};
    const campaignDataRecordsROP = this.state.campaignDataRecordsROP;
    tableFillData.headerTitleMain = 'ROP Details';
    tableFillData.subItems = {};
    tableFillData.subItems.type = 'ropTable';
    let sortedRopRecord = {};
    const sortedCampaignDataRecordsROP = [];
    const columnNames = ['cica_ropmaildate', 'cica_ropinhomedate', 'cica_roppolicynumber', 'cica_ropproductname', 'cica_ropmodepremium', 'cica_ropbillingmode', 'cica_roprange', 'cica_ropbenifitrecycle', 'cica_otherpolicestooffer'];
    const ropCampaign = {
      header: [strings.estROPMailDate,
        strings.estROPInHomeDate, strings.rOPPolicy,
        strings.rOPProductName, strings.rOPModePremium,
        strings.rOPBillingMode, strings.rOPRange, strings.rOPBenefitRecycle,
        strings.otherPoliciesToOffer],
      body: []
    };

    const formatColResultToDate = (columnDateValue) => {
      const formattedDate = new Date(columnDateValue);
      return (`${formattedDate.getMonth() + 1}/${formattedDate.getDate()}/${formattedDate.getFullYear()}`);
    };

    // const getBillingMode = (type, data) => {
    //   let typeOfBilling = '';
    //   if (type !== undefined && type !== null) {
    //     const piclistValue = type;
    //     typeOfBilling = data.find(obj => piclistValue === obj.value).label;
    //   }
    //   return typeOfBilling;
    // };

    _.sortBy(campaignDataRecordsROP, value => new Date(value.createdon))
    .reverse()
    .map((ropRecord, index) => {
      if (index < 5) {
        if (ropRecord.cica_purpose !== '') {
          ropCampaign.campaignPurpose = ropRecord.cica_purpose;
        }

        columnNames.map((columnHeader) => {
          switch (columnHeader) {
            case 'cica_ropmaildate':
            case 'cica_ropinhomedate':
              sortedRopRecord[columnHeader] = formatColResultToDate(ropRecord[columnHeader]);
              break;
            case 'cica_ropbenifitrecycle':
              if (ropRecord[columnHeader] === 'true') {
                sortedRopRecord[columnHeader] = 'Yes';
              } else {
                sortedRopRecord[columnHeader] = 'No';
              }
              break;
            // case 'cica_ropbillingmode':
            //   sortedRopRecord[columnHeader] = getBillingMode(ropRecord[columnHeader],
            //    this.props.picklistBillingMode);
            //   break;
            default:
              if (ropRecord[columnHeader] === '' ||
                ropRecord[columnHeader] === null ||
                ropRecord[columnHeader] === undefined) {
                sortedRopRecord[columnHeader] = 'NA';
              } else {
                sortedRopRecord[columnHeader] = ropRecord[columnHeader];
              }
              break;
          }
          return '';
        });
        sortedCampaignDataRecordsROP.push(sortedRopRecord);
        sortedRopRecord = {};
        return '';
      }
      return '';
    });

    ropCampaign.body = sortedCampaignDataRecordsROP;
    tableFillData.subItems.tableData = [];
    tableFillData.subItems.tableData.push(ropCampaign);
    return tableFillData;
  }

  getDataTemplate = () => {
    const { strings } = this.props;
    let tempDataTemplate = {};
    if (this.props.tabIndexLeadsCheck !== 2) {
      tempDataTemplate = {
        generalInfo: {
          data: [{ keyName: 'name', location: 0, displayName: strings.name },
            { keyName: 'primaryContact', location: 1, displayName: strings.primarycontact },
            { keyName: 'residentialPhone', location: 2, displayName: strings.residentialphone },
            { keyName: 'insuredDOB', location: 3, displayName: strings.insuredsdob },
            { keyName: 'fullCallType', location: 0, displayName: strings.calltype },
            { keyName: 'residentialAddress', location: 1, displayName: strings.residentialaddress },
            { keyName: 'alternatePhoneCarousel', location: 2, displayName: strings.alternatephone },
            { keyName: 'age', location: 3, displayName: strings.age },
            { keyName: 'language', location: 0, displayName: strings.language },
            { keyName: 'email', location: 1, displayName: strings.emailAddress },
            { keyName: 'doNotCallAfter', location: 2, displayName: strings.doNotCallAfter },
            { keyName: 'tenure', location: 3, displayName: strings.policyholderTenure }],
          headerName: strings.contactinfo
        },
        businessInfo: {
          data: [{ keyName: 'name', location: 0, displayName: strings.name },
          { keyName: 'firm', location: 1, displayName: strings.businessname },
          { keyName: 'businessPhoneCarousel', location: 2, displayName: strings.businessphone },
          { keyName: 'homeBusiness', location: 3, displayName: strings.homeBusiness },

          { keyName: 'fullCallType', location: 0, displayName: strings.calltype },
          { keyName: 'residentialAddress', location: 1, displayName: strings.businessaddress },
          { keyName: 'occupation', location: 2, displayName: strings.occupation },
          { keyName: 'yearsInBusiness', location: 3, displayName: strings.yearsInBusiness },

          { keyName: 'language', location: 0, displayName: strings.language },
          { keyName: 'email', location: 1, displayName: strings.emailAddress },
          { keyName: 'industry', location: 2, displayName: strings.industry },
          { keyName: 'numberofemployee', location: 3, displayName: strings.numberOfEmployees }],
          headerName: strings.businessInfo,
          subHeader: ''
        },
        miscInfo: {
          data: [
            { keyName: 'disposition', location: 0, displayName: strings.currentDisposition },
            { keyName: 'lastAssignedAgent', location: 1, displayName: strings.lastAssignedTo },
            { keyName: 'companySize', location: 2, displayName: strings.companySize },
            { keyName: 'leadType', location: 0, displayName: strings.leadtype },
            { keyName: 'lastDispositionState', location: 1, displayName: strings.lastDisposition },
            { keyName: 'jobTitle', location: 2, displayName: strings.jobTitle },
            { keyName: 'lastSellingAgent', location: 0, displayName: strings.sellingagent },
            { keyName: 'lastDispositionDate', location: 1, displayName: strings.lastDispositionDate },
            { keyName: 'bestWayToContactBefore', location: 2, displayName: strings.bestWayToContactBefore },
            { keyName: 'newPolicy', location: 0, displayName: strings.newPolicy },
            { keyName: 'isNeeedToContactBeforeVisit', location: 1, displayName: strings.isNeeedToContactBeforeVisit }
          ],
          headerName: strings.other,
          subHeader: ''
        },
        // policyInfo: {
        //   data: [{ keyName: 'assignedTo', location: 0, displayName: strings.assignedTo },
        //     { keyName: 'name', location: 0, displayName: strings.name },
        //     { keyName: 'isOrphaned', location: 0, displayName: strings.isOrphaned },
        //     { keyName: 'disposition', location: 1, displayName: strings.disposition },
        //     { keyName: 'description', location: 1, displayName: strings.description },
        //     { keyName: 'lastSelling', location: 1, displayName: strings.lastSelling },
        //     { keyName: 'lastassignedagentCode', location: 2,
        // displayName: strings.lastassignedagentCode }],
        //   headerName: strings.policydetails,
        //   subHeader: ''
        // }
      };
    } else {
      tempDataTemplate = {
        generalInfo: {
          data: [{ keyName: 'cica_customername', location: 0, displayName: strings.insuredNameIns },
            { keyName: 'cica_primarycontact', location: 1, displayName: strings.primarycontact },
            { keyName: 'cica_residentialphone', location: 2, displayName: strings.residentialphone },
            { keyName: 'cica_insuredsdob', location: 3, displayName: strings.insuredsdob },
            { keyName: 'cica_calltype', location: 0, displayName: strings.calltype },
            { keyName: 'cica_residentialaddress', location: 1, displayName: strings.residentialaddress },
            { keyName: 'cica_alternatephone', location: 2, displayName: strings.alternatephone },
            { keyName: 'cica_age', location: 3, displayName: strings.age },
            { keyName: 'cica_writingagent', location: 0, displayName: strings.writingagent },
            { keyName: 'cica_writingagentsmanager', location: 1, displayName: strings.writingagentsmanager },
            { keyName: 'cica_languagepreference', location: 2, displayName: strings.languagepreferenceIns },
            { keyName: 'cica_writingagentcode', location: 0, displayName: strings.writingagentcode }],
          headerName: strings.contactinfo
        },
        businessInfo: {
          data: [{ keyName: 'cica_customername', location: 0, displayName: strings.insuredNameIns },
            { keyName: 'cica_businessname', location: 1, displayName: strings.businessname },
            { keyName: 'cica_businessphone', location: 2, displayName: strings.businessphone },
            { keyName: 'cica_insuredsdob', location: 3, displayName: strings.insuredsdob },
            { keyName: 'cica_calltype', location: 0, displayName: strings.calltype },
            { keyName: 'cica_businessaddress', location: 1, displayName: strings.businessaddress },
            { keyName: 'cica_occupation', location: 2, displayName: strings.occupation },
            { keyName: 'cica_age', location: 3, displayName: strings.age },
            { keyName: 'cica_writingagent', location: 0, displayName: strings.writingagent },
            { keyName: 'cica_writingagentsmanager', location: 1, displayName: strings.writingagentsmanager },
            { keyName: 'cica_languagepreference', location: 2, displayName: strings.languagepreferenceIns },
            { keyName: 'cica_writingagentcode', location: 0, displayName: strings.writingagentcode }],
          headerName: strings.businessInfo,
          subHeader: ''
        },
        policyInfo: {
          data: [{ keyName: 'cica_appdate', location: 0, displayName: strings.appdate },
            { keyName: 'cica_initialpaymenttype', location: 0, displayName: strings.initialpaymenttype },
            { keyName: 'cica_recurringpaymenttype', location: 0, displayName: strings.recurringpaymenttype },
            { keyName: 'product', location: 1, displayName: strings.product },
            { keyName: 'cica_grossannualhouseholdincome', location: 1, displayName: strings.grossannualhouseholdincome },
            { keyName: 'cica_apv', location: 1, displayName: strings.apv },
            { keyName: 'cica_monthlypremiuim', location: 2, displayName: strings.monthlypremiuim },
            { keyName: 'cica_grossindividualannualincome', location: 2, displayName: strings.grossindividualannualincome },
            { keyName: 'cica_premiummode', location: 2, displayName: strings.premiummode },
            { keyName: 'cica_premiumbillingdate', location: 3, displayName: strings.premiumbillingdate }],
          headerName: strings.policydetails,
          subHeader: ''
        }
      };
    }
    return tempDataTemplate;
  }

  getCampaignDataTemplate = () => {
    const { strings } = this.props;
    const campaignInfo = {
      data: [{ keyName: 'cica_campaign', location: 0, displayName: strings.campaignName },
      { keyName: 'cica_recproduct1', location: 0, displayName: strings.recommendedBestProductToSell },
      { keyName: 'cica_recproduct2', location: 0, displayName: strings.recommendedNextBestProductToSell },
      { keyName: 'cica_purpose', location: 1, displayName: strings.campaignPurpose },
      { keyName: 'cica_purpose', location: 1, displayName: strings.hippa }],
      headerName: strings.campaignDescription,
    };
    return campaignInfo;
  }

  getTableData = (tableData) => {
    const tableFillData = {};
    const { listData, strings } = this.props;
    tableFillData.headerTitleMain = strings.policyDetails;
    tableFillData.subItems = {};
    tableFillData.subItems.type = 'table';

    let subTitleData = `${listData.cbeproduct1 ? listData.cbeproduct1 : ''}, ${listData.cbeproduct2 ? `${listData.cbeproduct2},` : ''}
${listData.cbeproduct3 ? `${listData.cbeproduct3},` : ''} ${listData.cbeproduct4 ? listData.cbeproduct4 : ''}`;

    subTitleData = subTitleData.replace(/(^\s*,) |-( ,\s*$)/g, '');
    tableFillData.subItems.footerData =
      [{ title: strings.valueAddProductsOwned, subTitle: subTitleData }];

    const inforcePolicies = {
      tableTitle: strings.inforcePolicies,
      header: [strings.policyNo, strings.formNo,
        strings.policy, strings.benefit, strings.premium,
        strings.mode, strings.t, strings.issueDate, strings.insuredName],
      body: []
    };
    const lapsedPolicies = {
      tableTitle: strings.lapsedPolicies,
      header: [strings.policyNo, strings.formNo, strings.policy,
        strings.benefit, strings.premium, strings.mode, strings.t,
        strings.issueDate, strings.lapseDate, strings.insuredName],
      body: []
    };
    const getFormattedBenefitAmount = (amount, amountType) => {
      if (amount) {
        // let formattedAmount = `$${amount.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')}`;
        let formattedAmount = `$${new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount)}`;
        switch (amountType) {
          case 'L':
            formattedAmount = `${formattedAmount}/LIF`;
            break;
          case 'D':
            formattedAmount = `${formattedAmount}/DAY`;
            break;
          case 'M':
            formattedAmount = `${formattedAmount}/MO`;
            break;
          case 'W':
            formattedAmount = `${formattedAmount}/WK`;
            break;
          case 'Y':
            formattedAmount = `${formattedAmount}/YR`;
            break;
          default:
            formattedAmount = `${formattedAmount}`;
            break;
        }
        return formattedAmount;
      }
      return '';
    };

    const formatCurrency = (currency) => {
      if (!isNaN(Number(currency))) {
        return `$${(Number(currency) / 100).toFixed(2)}`;
      }
      return 'NA';
    };

    const sortedData = (data, key, dateColumn) => {
      const accidentWithoutIssueDate = [];
      let accidentWithIssueDate = [];
      const healthWithoutIssueDate = [];
      let healthWithIssueDate = [];
      const lifeWithoutIssueDate = [];
      let lifeWithIssueDate = [];

      data.forEach((element) => {
        if ((element[dateColumn] === '' || element[dateColumn] === null) && element.cica_policyinfotype === '1') {
          accidentWithoutIssueDate.push(element);
        } else if (element.cica_policyinfotype === '1') {
          accidentWithIssueDate.push(element);
        } else if ((element[dateColumn] === '' || element[dateColumn] === null) && element.cica_policyinfotype === '2') {
          healthWithoutIssueDate.push(element);
        } else if (element.cica_policyinfotype === '2') {
          healthWithIssueDate.push(element);
        } else if ((element[dateColumn] === '' || element[dateColumn] === null) && element.cica_policyinfotype === '3') {
          lifeWithoutIssueDate.push(element);
        } else if (element.cica_policyinfotype === '3') {
          lifeWithIssueDate.push(element);
        }
      });
      accidentWithIssueDate =
        _.orderBy(accidentWithIssueDate, [(o) => { moment(o[dateColumn]).format('YYYY-MM-DD HH:mm:ss'); }], [key]);
      healthWithIssueDate =
        _.orderBy(healthWithIssueDate, [(o) => { moment(o[dateColumn]).format('YYYY-MM-DD HH:mm:ss'); }], [key]);
      lifeWithIssueDate =
        _.orderBy(lifeWithIssueDate, [(o) => { moment(o[dateColumn]).format('YYYY-MM-DD HH:mm:ss'); }], [key]);

      const mergeData = [...accidentWithIssueDate, ...accidentWithoutIssueDate,
        ...healthWithIssueDate, ...healthWithoutIssueDate, ...lifeWithIssueDate,
        ...lifeWithoutIssueDate];
      return mergeData;
    };

    if (typeof (tableData) === 'object') {
      if (Object.keys(tableData).length < 1) {
        tableFillData.subItems.tableData = [];
        tableFillData.subItems.tableData.push(inforcePolicies);
        tableFillData.subItems.tableData.push(lapsedPolicies);
        return tableFillData;
      }
    } else if (tableData.length < 1) {
      tableFillData.subItems.tableData = [];
      tableFillData.subItems.tableData.push(inforcePolicies);
      tableFillData.subItems.tableData.push(lapsedPolicies);
      return tableFillData;
    }
    const sortedIssueDate = sortedData(tableData, 'desc', 'cica_issuedate');
    sortedIssueDate.forEach((record) => {
      if (record.cica_policystatus === '1') {
        const recordData = [
          { name: 'policyNumber', value: record.cica_name },
          { name: 'FormNumber', value: record.cica_formnumber },
          { name: 'policy', value: record.cica_policyshortdesc },
          { name: 'benefit', value: getFormattedBenefitAmount(record.cica_decahbenamount, record.cica_ahbenperiod) },
          { name: 'premium', value: formatCurrency(record.cica_decmodelpremium) },
          { name: 'mode', value: record.cica_policymode },
          { name: 'T', value: record.cica_billingtype },
          { name: 'issueDate', value: record.cica_issuedate ? moment(record.cica_issuedate).format('MM-DD-YYYY') : '' },
          { name: 'insuredName', value: listData.name }
        ];
        inforcePolicies.body.push(recordData);
      }
    });
    const sortedLapseDate = sortedData(tableData, 'desc', 'cica_duedate');
    sortedLapseDate.forEach((record) => {
      if (record.cica_policystatus === '2') {
        const recordData = [
          { name: 'policyNumber', value: record.cica_name },
          { name: 'FormNumber', value: record.cica_formnumber },
          { name: 'policy', value: record.cica_policyshortdesc },
          { name: 'benefit', value: getFormattedBenefitAmount(record.cica_decahbenamount, record.cica_ahbenperiod) },
          { name: 'premium', value: formatCurrency(record.cica_decmodelpremium) },
          { name: 'mode', value: record.cica_policymode },
          { name: 'T', value: record.cica_billingtype },
          { name: 'issueDate', value: record.cica_issuedate ? moment(record.cica_issuedate).format('MM-DD-YYYY') : '' },
          { name: 'lapseDate', value: record.cica_duedate ? moment(record.cica_duedate).format('MM-DD-YYYY') : '' },
          { name: 'insuredName', value: listData.name }
        ];
        lapsedPolicies.body.push(recordData);
      }
    });
    tableFillData.subItems.tableData = [];
    tableFillData.subItems.tableData.push(inforcePolicies);
    tableFillData.subItems.tableData.push(lapsedPolicies);
    return tableFillData;
  };

  setDataTemplateForRenderingOnCallType = (callType) => {
    const { strings } = this.props;
    let tempdataTemplate = {};
    const dataTemplate = this.getDataTemplate();
    if (callType === 'Business') {
      // change the data template to have residential later
      // As everything is related to the order of keys, if we change the key order
      // data will automatically come in order
      // So for business we need to bring business first and change the header of secon
      tempdataTemplate.businessInfo = dataTemplate.businessInfo;
      tempdataTemplate.generalInfo = dataTemplate.generalInfo;
      tempdataTemplate.policyInfo = dataTemplate.policyInfo;
      tempdataTemplate.generalInfo.headerName = strings.residentialInfo;
      tempdataTemplate.businessInfo.headerName = strings.contactinfo;
    } else {
      tempdataTemplate = dataTemplate;
      tempdataTemplate.generalInfo.headerName = strings.contactinfo;
      tempdataTemplate.businessInfo.headerName = strings.businessInfo;
    }
    return tempdataTemplate;
  };

  getCarouselDataFromProps = () => {
    const propsData = this.props.listData;
    const dataTemplate = this.getDataTemplate();
    const campaignPropsData = this.state.campaignDataRecordsOthers;
    const ropPropsData = this.state.campaignDataRecordsROP;
    let warmLeadFlag = false;
    const { strings } = this.props;
    let subItems = [];
    const mainArray = [];
    const newMainArray = [];
    const dataTemplateUpdated = this.setDataTemplateForRenderingOnCallType(propsData.cica_calltype);
    Object.keys(dataTemplateUpdated).map((infoKeys, index) => { //eslint-disable-line
      dataTemplate[infoKeys].data.map((selectedData) => {
        Object.keys(propsData).map((propsDataKey) => {
          if (selectedData.keyName === propsDataKey) {
            if (subItems[selectedData.location] === undefined) {
              subItems[selectedData.location] = {
                subElements: []
              };
            }
            subItems[selectedData.location].subElements.push({
              title: selectedData.displayName,
              subTitle: propsData[propsDataKey] ? propsData[propsDataKey] : 'NA'
            });
          }
          return subItems;
        });
        return subItems;
      });
      if (mainArray[index] === undefined) {
        mainArray[index] = {
          subItems: [],
          headerTitleMain: dataTemplateUpdated[infoKeys].headerName ? dataTemplateUpdated[infoKeys].headerName : '',
          headerTitleSub: dataTemplateUpdated[infoKeys].subHeader ? dataTemplateUpdated[infoKeys].subHeader : '',
        };
      }
      mainArray[index].subItems = subItems;
      subItems = [];
      return mainArray;
    });
    if (this.props.tabIndexLeadsCheck !== 2) {
      if (Object.keys(this.props.policyData).length < 1) {
        if (this.state.tableData.length < 1) {
          mainArray.push(this.getTableData([]));
        } else {
          mainArray.push(this.state.tableData);
        }
      } else {
        mainArray.push(this.getTableData(this.props.policyData));
      }
      mainArray[2].subItems.map((subItem) => {
        subItem.subElements.map((subElement) => {
          if (subElement.title === strings.leadtype && subElement.subTitle !== 'Warm') {
            warmLeadFlag = true;
          }
          if (subElement.title === strings.leadtype && subElement.subTitle === 'Warm') {
            dataTemplate.businessInfo.industry = 'NA';
          }
          if (warmLeadFlag) {
            warmLeadFlag = false;
          }
          return '';
        });
        return '';
      });
      if (ropPropsData && ropPropsData.length > 0) {
        mainArray.push(this.getRopTableData());
      }

      if (campaignPropsData && campaignPropsData.length) {
        subItems = [];
        const campaignInfo = this.getCampaignDataTemplate();
        campaignPropsData.map((campaignRecordObject) => {
          campaignInfo.data.map((campaignInfoTemplate) => {
            if (campaignRecordObject[campaignInfoTemplate.keyName] !== undefined) {
              if (subItems[campaignInfoTemplate.location] === undefined) {
                subItems[campaignInfoTemplate.location] = {
                  subElements: []
                };
              }
              subItems[campaignInfoTemplate.location].subElements.push(
                {
                  title: campaignInfoTemplate.displayName,
                  subTitle: (campaignRecordObject[campaignInfoTemplate.keyName] === '' ||
                    campaignRecordObject[campaignInfoTemplate.keyName] === null ||
                    campaignRecordObject[campaignInfoTemplate.keyName] === undefined) ?
                    'NA' : this.checkForHIPPA(campaignRecordObject[campaignInfoTemplate.keyName], campaignInfoTemplate.displayName)
                });
            }
            return '';
          });
          const incrementSubItem = {
            subItems,
            type: 'OtherCampaignsFlexDivs',
            headerTitleMain: campaignInfo.headerName,
            headerTitleSub: ''
          };
          mainArray.push(incrementSubItem);
          subItems = [];
          return '';
        });
      }

      mainArray.map((subItem, index) => {
        if (index === 2) {
          newMainArray.push(mainArray[3]);
        } else if (index === 3) {
          newMainArray.push(mainArray[2]);
        } else {
          newMainArray.push(subItem);
        }
        return '';
      });
      return newMainArray;
    }
    mainArray.map((subItem, index) => {
      if (index === 2) {
        newMainArray.push(mainArray[2]);
      } else {
        newMainArray.push(subItem);
      }
      return '';
    });
    return newMainArray;
  };

  checkForHIPPA = (keyValue, displayName) => {
    const { strings } = this.props;
    let data;
    if (displayName === strings.hippa && (_.includes(keyValue, '_HIPAA_Active'))) {
      data = 'Y - Active';
    } else if (displayName === strings.hippa && (_.includes(keyValue, '_HIPAA_Lapsed'))) {
      data = 'Y - Lapsed';
    } else if (displayName === strings.hippa && (_.includes(keyValue, '_Active') && (!_.includes(keyValue, '_HIPAA')))) {
      data = ' N - Active';
    } else if (displayName === strings.hippa && (_.includes(keyValue, '_Lapsed') && (!_.includes(keyValue, '_HIPAA')))) {
      data = 'N - Lapsed';
    } else if (displayName === strings.hippa && (_.includes(keyValue, '_HIPAA'))) {
      data = 'Y';
    } else if (displayName === strings.hippa && (!_.includes(keyValue, '_HIPAA'))) {
      data = 'N';
    } else if (displayName === strings.campaignPurpose && (_.includes(keyValue, '_HIPAA'))) {
      const dataIndex = keyValue.indexOf('_HIPAA');
      data = keyValue.substring(0, dataIndex);
    } else if (displayName === strings.campaignPurpose && (!_.includes(keyValue, '_HIPAA') && (_.includes(keyValue, '_Active')))) {
      const dataIndex = keyValue.indexOf('_Active');
      data = keyValue.substring(0, dataIndex);
    } else if (displayName === strings.campaignPurpose && (!_.includes(keyValue, '_HIPAA') && (_.includes(keyValue, '_Lapsed')))) {
      const dataIndex = keyValue.indexOf('_Lapsed');
      data = keyValue.substring(0, dataIndex);
    } else {
      data = keyValue;
    }
    return data;
  }

  overrideDecorators = [
    {
      component: OverrideCarousel,
      position: 'BottomCenter'
    },
    {
      component: CarouselLeftArrow,
      position: 'CenterLeft'
    },
    {
      component: CarouselRightArrow,
      position: 'CenterRight'
    }
  ];

  changeHeader = (e) => {
    if (e !== this.state.headerIndex) {
      this.setState({
        headerIndex: e,
        CarousalHeaderTitle: this.getCarouselDataFromProps()[e].headerTitleMain,
        CarousalHeaderSubTitle: (this.getCarouselDataFromProps()[e].headerTitleSub !== undefined) ? this.getCarouselDataFromProps()[e].headerTitleSub : ''
      });
    }
  };

  closePopup = (closeCarousel) => {
    this.setState({
      insButtonCarouselType: ''
    });
    if (closeCarousel) {
      this.props.closeCarousel(this.props.clickedIndex);
    }
  }
  buttonCarouselAction = (index, type) => {
    if (this.state.insButtonCarouselType !== '') {
      this.setState({
        insButtonCarouselType: ''
      });
    } else {
      this.setState({
        insButtonCarouselType: type
      });
    }
  }

  renderPopUp = () => {
    let label = '';
    const { strings } = this.props;
    let insPopupType = 0;
    if (this.state.insButtonCarouselType !== '') {
      if (this.state.insButtonCarouselType === 'customerExperience') {
        label = strings.customerexperience;
        insPopupType = 1;
      } else if (this.state.insButtonCarouselType === 'trainingOpportunity') {
        label = strings.trainingopportunity;
        insPopupType = 2;
      } else if (this.state.insButtonCarouselType === 'noContact') {
        label = strings.nocontact;
        insPopupType = 3;
      } else if (this.state.insButtonCarouselType === 'comments') {
        label = strings.comments;
        insPopupType = 4;
      } else if (this.state.insButtonCarouselType === 'duplicateInspection') {
        label = strings.duplicateinspection;
        insPopupType = 5;
      } else if (this.state.insButtonCarouselType === 'submit') {
        label = strings.submit;
        insPopupType = 6;
      } else if (this.state.insButtonCarouselType === 'script') {
        label = strings.script;
        insPopupType = 7;
      }

      return (
        <InspectionsPopup
          textLabel={label}
          closePopup={this.closePopup}
          clickedIndex={this.props.clickedIndex}
          insPopupType={insPopupType}
          strings={this.props.strings}
          insButtonCarouselType={this.state.insButtonCarouselType}
          wholeData={this.props.listData}
          currentLanguage={this.props.currentLanguage}
          ownerId={this.props.ownerId}
        />
      );
    }
    return '';
  }

  render() { //eslint-disable-line
    return ( //eslint-disable-line
      <div className={styles.flexContainer} >
        <div className={isIE ? styles.ieCarouselHeader : styles.carouselHeader} >
          <CarouselHeader
            clickedIndex={this.props.clickedIndex}
            closeCarousel={this.props.closeCarousel}
            CarousalHeaderTitle={this.state.CarousalHeaderTitle}
          />
        </div>
        <div className={isIE ? styles.ieMainCarouselBody : ((this.props.tabIndexLeadsCheck !== 2) ? //eslint-disable-line
          styles.mainCarouselBodyLeads : styles.mainCarouselBody)}
        >
          {isIE && <style>
            {`.slider-list {
                height: 250px !important;
            }`}
          </style>}
          {(this.props.tabIndexLeadsCheck !== 2) && <style>
            {
              `.slider-decorator-0 {
                bottom: -4em !important;
            }`}
          </style>}
          <Carousel
            afterSlide={this.changeHeader}
            speed={400}
            swiping
            dragging
            fixedHeight={isIE || false}
            decorators={this.overrideDecorators}
          >
            {
              this.getCarouselDataFromProps().map((subItems, index) => { //eslint-disable-line
                if (subItems.type === 'OtherCampaignsFlexDivs') {
                  return (
                    <div key={`CarouselItemData, ${index}!`}>
                      <div key={`carouselMainBody, ${index}!`}>
                        <InspCarouselItem
                          CarouselItemData={subItems.subItems}
                          key={`subItems,${index}`}
                          strings={this.props.strings}
                          CarousalHeaderTitle={this.state.CarousalHeaderTitle}
                          isIE={isIE || false}
                        />
                      </div>
                    </div>
                  );
                }
                return (
                  <InspCarouselItem
                    CarouselItemData={subItems.subItems}
                    key={`subItems,${index}`}
                    strings={this.props.strings}
                    CarousalHeaderTitle={this.state.CarousalHeaderTitle}
                    isIE={isIE || false}
                  />
                );
              })
            }
          </Carousel>
        </div>
        { (this.props.tabIndexLeadsCheck === 2) && <InspectionCarouselFooter
          wholeData={this.props.listData}
          buttonCarouselAction={this.buttonCarouselAction}
          clickedIndex={this.props.clickedIndex}
          strings={this.props.strings}
          closeCarousel={this.props.closeCarousel}
          currentLanguage={this.props.currentLanguage}
        /> }
        {this.renderPopUp()}
      </div>
    );
  }
}
const mapStateToProps = state => ({
  policyData: state.assign.policyData,
  campaignData: state.assign.campaignData
});
export default connect(mapStateToProps, actions)(InspCarousel);



// WEBPACK FOOTER //
// ./src/containers/InspCarousel/InspCarousel.js